<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import HotelMap from '@/components/search/offers/HotelMap.vue'
    import ActivityMapInfoWindow from '@/components/activities/search/ActivityMapInfoWindow.vue'

    @Component({mixins: [HotelMap]})
    export class ActivityMap extends Vue {
        pointInfo = {}

        async load() {
            await this.initMap()
            this.setMarkers(this.offers)
        }

        setMarkers(offers) {
            this.markers.forEach(marker => marker.setMap(null))
            this.markers = []
            if (!offers.length) return
            offers.forEach(offer => {
                this.addMarker(offer)
            })
            this.bounds = new this.google.maps.LatLngBounds()
            this.markers.forEach(marker => this.bounds.extend(marker.getPosition()))
            this.setMapPosition()
        }

        addMarker(offer) {
            let position
            if (offer.latitude && offer.longitude) {
                position = {
                    lat: Number(offer.latitude),
                    lng: Number(offer.longitude),
                }
            } else {
                return
            }

            if (this.markers.findIndex(marker => marker.position === position) !== -1) return

            const marker = new this.google.maps.Marker({
                position,
                icon: this.createMarkerIcon(offer),
                map: this.map,
                data: offer,
            })

            marker.addListener('click', () => {
                if (!marker.infoWindow) {
                    this.showInfoWindow(marker)
                }
            })

            this.markers.push(marker)
            return marker
        }

        async showInfoWindow(marker) {
            const markerWithInfoWindow = this.markers.find(marker => marker.infoWindow)
            if (markerWithInfoWindow) {
                markerWithInfoWindow.infoWindow.close()
                markerWithInfoWindow.infoWindow = null
            }
            const content = document.createElement('div')
            useCreateComponent({
                component: ActivityMapInfoWindow,
                props: {
                    propData: marker.data,
                },
                el: content,
            })
            marker.infoWindow = new this.google.maps.InfoWindow({content})
            this.google.maps.event.addListener(marker.infoWindow, 'closeclick', () => {
                marker.infoWindow.close()
                marker.infoWindow = null
            })
            marker.infoWindow.open(this.map, marker)
        }

        setMapPosition() {
            this.map.fitBounds(this.bounds)
            this.mapPositionInit = true
        }

        saveMapPosition() {}
    }

    export default {...toNative(ActivityMap), ssrRender: HotelMap.ssrRender}
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';

    .map {
        position: fixed;

        @media #{map.get(settings.$display-breakpoints, 'xs')} {
            margin-left: -(settings.$container-padding-x);
        }

        > div {
            height: 100%;
        }
    }
</style>
